import _ from 'lodash'


const fillContentInMatrixIfNotExist = (index:number,value:string,matrix:string[])=>{
    // console.log('fillContentInMatrixIfNotExist matrix[index] ',matrix[index] )
    if(matrix[index] === undefined){
        matrix[index] = value
    }
}

export const getChunk = (data:string[])=>{
    const columns:string[][] = []
    let currentColumn = 0
    for(let i =0;i<data.length;i++){
        const bs = data[i]
        console.log('data[i]',data[i],bs,i)
        const colContent = columns[currentColumn] 
        if(!colContent){
          columns[currentColumn] = [bs]
        }else{
          if(colContent[0] == bs){
            columns[currentColumn].push(bs)
          }else{
            currentColumn++
            columns[currentColumn] = [bs]
          }
        }
      }
      return columns;
}
export const getRoute = (data:string[])=>{
    const columns = getChunk(data) 
    // console.log('columns',columns)
    const columnConfigs:{turnPosition:number,value?:string,count?:number}[] = []
    // 角判断
    for(let columnIndexForColumns=columns.length-1; columnIndexForColumns >= 0; columnIndexForColumns--){

        let columnIndexForColumnConfig = columns.length-1-columnIndexForColumns;
        let configInColumn = columnConfigs[columnIndexForColumnConfig]
        if(!configInColumn){
            columnConfigs[columnIndexForColumnConfig] = {turnPosition:6,value:columns[columnIndexForColumns][0],count:columns[columnIndexForColumns].length}
            configInColumn = columnConfigs[columnIndexForColumnConfig]
            // console.log('configInColumn',configInColumn,columnIndexForColumnConfig,'columnConfigs',columnConfigs)
        }

        // 说明本列有被其它龙占领
        if(!configInColumn.value){
            // if(columns[columnIndexForColumns].length > configInColumn.turnPosition){
            //     configInColumn.turnPosition--
            // }
            
            configInColumn.value = columns[columnIndexForColumns][0]
            configInColumn.count = columns[columnIndexForColumns].length
        }

        const overflowCount = configInColumn.count - configInColumn.turnPosition
        // console.log('overflowCount',overflowCount)
        if(overflowCount>0){
            _.times(overflowCount,n=>{
                let columnConfig = columnConfigs[columnIndexForColumnConfig+n+1] 
                if(!columnConfig){
                    columnConfigs[columnIndexForColumnConfig+n+1] = {turnPosition:configInColumn.turnPosition-1}
                    // console.log('add column for turn columnConfigs[columnIndexForColumnConfig+n+1]',columnConfigs[columnIndexForColumnConfig+n+1],'overflowCount',overflowCount)
                }else{
                    columnConfig.turnPosition--
                }
                // console.log('columnConfigs[columnIndexForColumnConfig+n+1]',columnConfigs[columnIndexForColumnConfig+n+1],'n',n,'columnIndexForColumns',columnIndexForColumns)
            })
            
        }
        // const columnData = columns[columnIndex]
        // let overflowCount = 0
        // if(columnData.length>6){
        //     overflowCount = columnData.length - 6
        // }
    }
    // @ts-ignore
    const resultMatrix = columnConfigs.map(cf=>[])
    // console.log('columnConfigs',columnConfigs)
    for(let i = 0; i<columnConfigs.length;i++){
        const columnConfig = columnConfigs[i]
        let matrixOfCurrentColumn = resultMatrix[i]
        _.times(6,n=>{
            // if(n<columnConfig.turnPosition-1){
            //     fillContentInMatrixIfNotExist(n,columnConfig.value,matrixOfCurrentColumn)
            // }
            if(n<=columnConfig.count-1){
                fillContentInMatrixIfNotExist(n,columnConfig.value,matrixOfCurrentColumn)
            }else{
                fillContentInMatrixIfNotExist(n,null,matrixOfCurrentColumn)
            }
        })
        const overflowCount = columnConfig.count - columnConfig.turnPosition
        _.times(overflowCount,n=>{
            // 下一列
            const nextMatrix = resultMatrix[i+n+1]
            fillContentInMatrixIfNotExist(columnConfig.turnPosition-1,columnConfig.value,nextMatrix)
        })   
    }
    if(resultMatrix.length<24){
        _.times(24-resultMatrix.length,n=>{
            resultMatrix.push([null,null,null,null,null,null,])
        })
    }
    console.log('resultMatrix',resultMatrix)
    return resultMatrix
}